import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M8 19a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2zM23 19a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2z"/><path d="M29 5H3a2 2 0 00-2 2v15a2 2 0 002 2h3.3a2.4 2.4 0 01-.2-.4.6.6 0 000-.1 1.8 1.8 0 010-1 2.4 2.4 0 01.2-.5 2 2 0 013.4 0 2.4 2.4 0 01.2.4.6.6 0 000 .1 1.8 1.8 0 010 1 2.4 2.4 0 01-.2.5h11.6a2.4 2.4 0 01-.2-.4.6.6 0 000-.1 1.8 1.8 0 010-1 2.4 2.4 0 01.2-.5 2 2 0 013.4 0 2.4 2.4 0 01.2.4.6.6 0 000 .1 1.8 1.8 0 010 1 2.4 2.4 0 01-.2.5H29a2 2 0 002-2V7a2 2 0 00-2-2zm-10 7H3V7h16zm10 0h-8V7h8z"/>';
export var BusSideSVG = function BusSideSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BusSideSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BusSideSVG);